export default __webpack_public_path__ + "static/media/paso24.5b65ffee.png";